<template>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <v-form ref="form">
          <v-container class='py-0'>
            <v-toolbar-title>{{$t('keywords.register')}}</v-toolbar-title>
            <v-row>
              <v-col cols='12' md='4'>
                <v-text-field
                  :rules="requiredRules(clientDTO.clientName)"
                  name='clientName'
                  :label='$t("client.name")'
                  v-model='clientDTO.clientName'
                />
              </v-col>
              <v-col cols='12' md='4'>
                <v-text-field
                  required
                  :readonly="isUpdating"
                  :rules="alphaNumericRules(clientDTO.urlPrefix)"
                  name='urlPrefix'
                  :label='$t("client.url.prefix")'
                  v-model='clientDTO.urlPrefix'
                />
              </v-col>
              <v-col cols='12' md='3'>
                <v-text-field
                  :rules="requiredRules(clientDTO.token)"
                  required
                  name='token'
                  :label='$t("client.token")'
                  v-model='clientDTO.token'
                />
              </v-col>

              <v-col cols="12" sm="12">
                <RoutingkeySelect v-model="clientDTO.routingkey" :rules="requiredRules(clientDTO.routingkey)" />
              </v-col>

              <v-col class="d-flex justify-center align-center" cols='12' md='6' >
                <v-text-field
                  required
                  name='accessUrl'
                  :label="$t('client.url.access')"
                  v-model='clientDTO.accessUrl'
                  type="text"
                  :rules="requiredRules(clientDTO.accessUrl)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols='12' sm='2'>
                <v-switch
                  name="active"
                  :label="$t('check.active')"
                  v-model='clientDTO.active'
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6">
                <v-dialog
                  ref="dialog"
                  v-model="modalDateCut"
                  :return-value.sync="cutDate"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedDateFormatted"
                      :label="$t('client.date')"
                      readonly
                      v-on="on"
                      append-icon="mdi-close"
                      @click:append="cutDate = null"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="cutDate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalDateCut = false">{{$t('button.cancel')}}</v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(cutDate)">{{$t('button.save')}}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols='12' md='4'>
                <v-text-field
                  :rules="[]"
                  name='charterCode'
                  :label='$t("client.charterCode")'
                  v-model='clientDTO.charterCode'
                />
              </v-col>
              <v-col cols='12' md='4'>
                <v-text-field
                  :rules="[]"
                  name='contactAddress'
                  :label='$t("client.contactAddress")'
                  v-model='clientDTO.contactAddress'
                />
              </v-col>
              <v-col>
              <v-select
                  v-model="clientDTO.clientType"
                  name='clientType'
                  :label='$t("client.clientType")'
                  :items="clientTypeOptions"
                  item-value="value"
                  :rules="requiredRules(clientDTO.clientType)"
                  />
              </v-col>
            </v-row>

          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols='12' class='text-right'>
        <v-btn color='success' class='mr-0' @click='saveItem'>{{$t('button.save')}}</v-btn>
        <v-btn color='blue darken-1' text @click='close'>{{$t('button.cancel')}}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Servico from '@/services/ClientService'
import LocalStorageService from '../../services/LocalStorageService'
import { alphaNumericRules, requiredRules } from '../../utils/rules'
import UtilsClientType from '@/utils/ClientType'
import RoutingkeySelect from '../core/RoutingkeySelect.vue'

export default {
  name: 'clientForm',
  props: {
    identifier: String
  },
  data: () => ({
    alphaNumericRules,
    requiredRules,
    clientDTO: {
      type: null,
      urlPrefix: '',
      clientName: '',
      cutDate: null,
      active: true,
      token: '',
      platform: false,
      accessUrl: '',
      routingkey: '',
      clientPrefix: '',
      charterCode: '',
      clientType: '',
      contactAddress: ''
    },
    defaultUrl: 'https://seniorconnect.com.br:9010',
    clientTypeOptions: UtilsClientType.findAll(),
    modalDateCut: false,
    isUpdating: false,
    cutDate: null
  }),
  computed: {
    computedDateFormatted () {
      const formatted = this.formatDate(this.cutDate)
      return formatted
    }
  },
  watch: {
    computedDateFormatted (val) {
      this.clientDTO.cutDate = val
    }
  },
  mounted () {
    this.loadDB()
  },
  methods: {
    formatDate (date) {
      if (!date) { return null }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) { return null }
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    loadDB () {
      if (this.identifier) {
        Servico.findById(this.identifier)
          .then(response => {
            this.isUpdating = true
            this.clientDTO = response.data
            this.cutDate = this.parseDate(this.clientDTO.cutDate)
          })
          .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
      }
    },
    async saveItem () {
      this.clientDTO.lastModifiedBy = LocalStorageService.getUsername()
      this.clientDTO.clientPrefix = LocalStorageService.getClientPrefix()
      this.clientDTO.platform = !!this.clientDTO.accessUrl.includes('seniorconnect.com.br')

      if (this.$refs.form.validate()) {
        if (this.isUpdating) this.updateItem()
        else this.createItem()
      } else {
        this.$message.error(this.$t('warnings.validation.fill_required_fields'))
      }
    },
    createItem () {
      Servico.insert({ ...this.clientDTO, accessUrl: this.clientDTO.accessUrl })
        .then(() => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },
    updateItem () {
      Servico.update({ ...this.clientDTO, accessUrl: this.clientDTO.accessUrl })
        .then(() => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },
    close () {
      this.$emit('editItem', true, null)
    }
  },
  components: { RoutingkeySelect }
}
</script>
